import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { HttpRequestService } from '@ipensii/shared/data-access-shared';

@Component({
  selector: 'ip-shared-loading-bar',
  standalone: true,
  imports: [CommonModule, ProgressBarModule],
  templateUrl: 'loading-bar.component.html',
})
export class LoadingBarComponent {
  readonly loadingBar = inject(HttpRequestService);
}
